import { PlanFeatureType } from '@lib/sanity/queries/modules/pricingMain/types';
import Image from 'next/image';
import cn from '../../../utils/cn';

type PlanFeatureImageVideoType = {
  imageVideo: PlanFeatureType['imageVideo'];
};

export default function PlanFeatureImageVideo({ imageVideo }: PlanFeatureImageVideoType) {
  if (!imageVideo?.image && !imageVideo?.video) {
    return null;
  }

  const { image, video } = imageVideo;
  const className = cn('h-[105px] w-[180px]');

  if (image) {
    return (
      <Image
        src={image?.asset?.url ?? ''}
        alt={image?.asset?.originalFilename ?? ''}
        loading="lazy"
        width="180"
        height="105"
      />
    );
  }

  return <video loop muted autoPlay playsInline src={video?.url} preload="auto" className={className} />;
}
